export default {
  groups: state => {
    return state.groups
  },
  loading: state => {
    return state.loading
  }
}
